/**
 * 横向组织机构树
 */
class GoingSvgTree {
    constructor(d3, options, data,initFlag=true) {
        let {width,height, containerId, changeSizeLabel,setSvgEye,nodeClick} = options;
        this.containerWidth=width;
        this.containerHeight=height;
        if (changeSizeLabel != null) {
            this.changeSizeLabel = changeSizeLabel;
        }
        if(setSvgEye!=null){
            this.setSvgEye=setSvgEye;
        }
        if(nodeClick!=null){
            this.nodeClick=nodeClick;
        }
        this._initOptions(options);
        this.d3=d3;
        this._sizeLabel = 100;
        this.nodeBgColor="#2D7EDC";
        this.containerId = containerId;
        if(initFlag){
            this.drawTree({width, d3, data},"her");
        }
    }
}

/**
 * 初始化相关参数
 * @param options
 * @private
 */
GoingSvgTree.prototype._initOptions = function (options) {
    //默认配置
    let defConfi={
        circleWidth:8,//展开收缩圆圈对宽度
        nodeColor:'#2D7EDC',//节点默认颜色
        nodeOverColor:"#F6A42E",//节点移动上去对颜色
        nodeHeight:33,//节点默认的高度
        svgEye:true,//是否需要鹰眼
        defWidth:110,//默认节点的宽度
        height:0,
        showLevel:2,
        width:0,
        nodeLeftSpace:190,//节点左右的间隔
        nodeTopSpace:40,//节点上面区域的间隔
        nodeWidth:[80,90,120,120]//不同层级 节点的宽度
    };


    this.options=$.extend(defConfi, options);
    //设置当前最大层级
    this.maxDepth=this.options.showLevel;
};

/**
 * 设置显示对层数
 * @param showLevel
 * @returns {number}
 */
GoingSvgTree.prototype.setShowLevel= function (showLevel) {
    return this.options["showLevel"]=parseInt(showLevel)-1;
};

/**
 * 销毁当前的树对象
 */
GoingSvgTree.prototype.destruction = function () {
    $("#"+ this.containerId).html("");
    for (let pro in this.options) {
        this.options[pro] = null;
    }
    for (let pro in this) {
        this[pro] = null;
    }
};

function _parseTransform(oldTrans){
//    translate(102.66445851335789,150.7511946899031) scale(0.9958497530944581)
    let translate=oldTrans.split(" ")[0];
    let x=translate.split("translate(")[1].split(",")[0];
    let y=translate.split(",")[1].split(")")[0];
    let k=1;
    if(oldTrans.indexOf("scale")>0){
        k=oldTrans.split(" ")[1].split("scale(")[1].split(")")[0];
    }
    return {x,y,k};
}

/**
 * 对图像进行大小变化
 * @param type
 */
GoingSvgTree.prototype.changeSvgSize = function () {
    let treeObj=this;
    let oldTrans=treeObj.svgObj.attr("transform");
    let {x,y,k}=_parseTransform(oldTrans);
    k=parseFloat(treeObj._sizeLabel)/100;
    treeObj.svg.transition().duration(10).call(
        treeObj.zoom.transform,
        treeObj.d3.zoomIdentity.translate(x,y).scale(k)
    );

};

/**
 * 获取图像size的label
 * @param type
 */
GoingSvgTree.prototype.getSizeLabel = function () {
    return this._sizeLabel + "%";
};

/**
 * 根据类型进行图像大小的变化
 * @param type
 */
GoingSvgTree.prototype.sizeChange = function (type) {
    if (type === "big") {
        //如果放到到200%则不能再放大了
        this._sizeLabel = parseFloat(this._sizeLabel) + 10;
        if (parseFloat(this._sizeLabel) > 200) {
            this._sizeLabel = parseFloat(this._sizeLabel) - 10;
            return;
        }
    } else if (type === "small") {
        //如果缩小大50%了则不能再缩小了
        this._sizeLabel = parseFloat(this._sizeLabel) - 10;
        if (parseFloat(this._sizeLabel) < 50) {
            this._sizeLabel = parseFloat(this._sizeLabel) + 10;
            return;
        }
    } else {
        this._sizeLabel = 100;
    }
    this.changeSvgSize();
};

/**
 * 对svg添加缩放功能
 * @param d3
 * @param svg
 * @param root
 * @private
 */
GoingSvgTree.prototype._initZoom = function (d3, svg, root, g) {
    let treeObj = this;
    let sizeTimer = null;

    //进行大小变化
    function zoomed() {
        treeObj._sizeLabel = parseFloat(d3.event.transform.k).toFixed(2)*100+"%";
        treeObj._sizeLabel=parseFloat(treeObj._sizeLabel).toFixed(2);
        if (treeObj.changeSizeLabel != null) {
            if (sizeTimer != null) {
                clearTimeout(sizeTimer);
            }
            try{
                sizeTimer = setTimeout(() => {
                    treeObj.changeSizeLabel&&treeObj.changeSizeLabel(treeObj._sizeLabel);
                }, 10);
            }catch (e) {
                console.log(e,"--zoomed-");
            }

        }
        g.attr("transform", d3.event.transform);
    }

    const zoom = d3.zoom()
        .scaleExtent([1 / 2, 10])
        .on("zoom", zoomed);
    treeObj.zoom=zoom;
    //scaleExtent设置放大缩小的方法


    if(this.treeType==='ver'){
        svg.call(zoom).transition().duration(10).call(
            zoom.transform,
            d3.zoomIdentity.translate(10, 10)
        );
    }else{
        svg.call(zoom).transition().duration(10).call(
            zoom.transform,
            d3.zoomIdentity.translate(100, 150)
        );
    }

};


let eysScroller=null;
/**
 * 移动svg图 鹰眼拖动
 * @param moveBaiFen
 */
GoingSvgTree.prototype.moveSvg=function(moveBaiFen){
    if(eysScroller!=null){
        clearTimeout(eysScroller);
    }
    eysScroller=setTimeout(()=>{
        let scrollWid=(moveBaiFen*100-100)/100*this.scrollerWidth;
        $('#' + this.containerId).parent().animate({scrollLeft:scrollWid + "px"}, 90);
    },100);

};

/**
 * 初始化点击节点状态
 * @param source
 * @param d3
 * @private
 */
GoingSvgTree.prototype._initSourceNode=function({source,d3}){
    if(source.children!=null){
        source.children.forEach((itemObj,index)=>{
            if(index===0){
                itemObj["first"]=true;
            }else if(index===(source.children.length-1)){
                itemObj["last"]=true;
            }else{
                itemObj["path"]=false;
            }
        });
        d3.select("#cir_"+source.id).attr("opacity", 1);
        d3.select("#icon_"+source.id).attr("opacity", 1).attr("xlink:href",window.SysConfigUtils.go_eplat_adress+"/static/svg/line.svg");
    }else{
        if(source.hasChildren){
            d3.select("#cir_"+source.id).attr("opacity", 1);
            d3.select("#icon_"+source.id).attr("opacity", 1);
            d3.select("#icon_"+source.id).attr("xlink:href",window.SysConfigUtils.go_eplat_adress+"/static/svg/plus.svg");
        }else{
            d3.select("#cir_"+source.id).attr("opacity", 0);
            d3.select("#icon_"+source.id).attr("opacity", 0);
        }
    }

};
//绘制节点
GoingSvgTree.prototype._drawNodes=function(source,options,transition){
    let {root,gNode,d3}=options;
    //初始化点击节点状态
    this._initSourceNode({source,d3});
    let treeObj=this;
    const nodes = root.descendants().reverse();
    // Update the nodes…
    const node = gNode.selectAll("g")
        .data(nodes, (d) =>{
            if(d["depth"]>treeObj.maxDepth){
                treeObj.maxDepth=d.depth;
            }
            return d.id;
        });


    const nodeEnter=this._initNodePostion(node,source,options);
    this._appendNode(nodeEnter,d3);
    //添加展开收缩图标
    this._appendExpandImg(nodeEnter,d3);
    //增加字信息
    this._appendText(nodeEnter);

    this._initShowNodePosition(node,nodeEnter,transition);


    // Transition exiting nodes to the parent's new position.
    node.exit().transition(transition).remove()
        .attr("transform", d => `translate(${source.y},${source.x})`)
        .attr("fill-opacity", 0)
        .attr("stroke-opacity", 0);
};

GoingSvgTree.prototype._initShowNodePosition=function(node,nodeEnter,transition){
    // Transition nodes to their new position.
    node.merge(nodeEnter).transition(transition)
        .attr("transform", d => `translate(${d.y},${d.x})`)
        .attr("fill-opacity", 1)
        .attr("stroke-opacity", 1);
};


GoingSvgTree.prototype._initNodePostion=function(node,source,options){
    let treeObj=this;

    // Enter any new nodes at the parent's previous position.
    let nodeEnter = node.enter().append("g")
        .attr("transform", (d) => {
            if(d.children!=null){
                d.children.forEach((itemObj,index)=>{
                    if(index===0){
                        itemObj["first"]=true;
                    }else if(index===(d.children.length-1)){
                        itemObj["last"]=true;
                    }else{
                        itemObj["path"]=false;
                    }
                });
            }

            return `translate(${source.x0},${source.y0+40})`;
        })
        .attr("fill-opacity", 0)
        .attr("stroke-opacity", 0)
        .on("click", d => {
            if(this.nodeClick){
                this.nodeClick(d);
            }
            if(d["depth"]===0){
                return void(0);
            }
            d.children = d.children ? null : d._children;
            treeObj.expandNode(d,options);
        });
    return nodeEnter;
};
GoingSvgTree.prototype._appendNode=function(nodeEnter,d3){
    let treeObj=this;
    //绘制节点
    nodeEnter.append("rect")
        .attr("rx", 4)
        .attr("ry", 4)
        .attr("width",  (d)=> {
            d.nodeWidth=this.options["nodeWidth"][d.depth]||this.options["defWidth"];
            return d.nodeWidth;
        })
        .attr("height",  (d)=> {
            d.nodeHeight=this.options["nodeHeight"];
            return this.options["nodeHeight"];
        })
        .attr("fill", treeObj.options["nodeColor"])
        .on("mouseover",function(){
            d3.select(this)
                .attr("fill",treeObj.options["nodeOverColor"]);
        })
        .on("mouseout",function(){
            d3.select(this)
                .transition()
                .duration(30)
                .attr("fill",treeObj.options["nodeColor"]);
        })
        .attr("stroke-width", 10);

    this._appendCircle(nodeEnter);

};

/**
 * 绘制圆圈圈
 * @param nodeEnter
 * @private
 */
GoingSvgTree.prototype._appendCircle=function(nodeEnter){
    let treeObj=this;
    nodeEnter.append("circle")
        .attr("r", this.options.circleWidth)
        .attr("fill", "#fff")
        .attr("stroke", treeObj.options["nodeOverColor"])
        .attr("transform", (d) => {
            return `translate(${d.nodeWidth},${parseFloat(this.options.nodeHeight)/2-2})`;
        })
        .attr("id", (d) => {
            return "cir_"+ d.id;
        })
        .attr("fill-opacity", (d)=>{
            return d.depth>0?1:0;
        })
        .attr("stroke-opacity",(d)=>{
            return d.depth>0?1:0;
        })
        .attr("stroke-width", (d)=>{
            return d.depth>0?1:0;
        });
};
/**
 * 添加展开 收缩图标
 * @param nodeEnter
 * @param d3
 * @private
 */
GoingSvgTree.prototype._appendExpandImg=function(nodeEnter,d3){
    let treeObj=this;
    nodeEnter.append("image")
        .attr("xlink:href",(d)=>{
            if(d.depth>=treeObj.options["showLevel"]&&d.hasChildren){
                return window.SysConfigUtils.go_eplat_adress+"/static/svg/plus.svg";
            }else{
                if(d.children){
                    return window.SysConfigUtils.go_eplat_adress+"/static/svg/line.svg";
                }else{
                    d3.select("#cir_"+d.id).attr("opacity", 0);
                    d3.select("#icon_"+d.id).attr("opacity", 0);
                }
            }
        })
        .attr("width", 12)
        .attr("id", (d) => {
            return "icon_"+d.id;
        })
        .attr("x", (d) => {
            return d.nodeWidth-6;
        })
        .attr("y", (d) => {
            return parseFloat(this.options.nodeHeight)/2-8;
        })
        .attr("opacity", (d)=>{
            return d.depth>0?1:0;
        })
        .attr("height", 12);
};

/**
 * 添加显示对字体
 * @param nodeEnter
 * @private
 */
GoingSvgTree.prototype._appendText=function(nodeEnter){
    nodeEnter.append("text")
        .attr("y", parseFloat(this.options.nodeHeight)/2+3)
        .attr("class", "treeText")
        .attr("x", d => d._children ? 8 : 8)
        .text(d => d.data.name)
        // .clone(true).lower()
        .attr("stroke-linejoin", "round")
        .attr("stroke-width", "1px")
        .style('stroke',"#FFF")
        .attr("stroke", "#fff");
};

GoingSvgTree.prototype.getSvgHeight=function(root){
    const margin = ({top: 10, right: 120, bottom: 10, left: 40});
    let left = root;
    let right = root;
    root.eachBefore(node => {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
    });
    this.moveHeight=-((left.x ) - margin.top);
    let svgHeight = (right.x + this.options.nodeHeight/2) - (left.x - this.options.nodeHeight/2) + margin.top + margin.bottom;
    //如果高度没有超过屏幕高度 则采用屏幕高度
    if(svgHeight<this.containerHeight){
        this.svgHeight=this.containerHeight;
    }else{
        this.svgHeight=svgHeight;
    }
    return this.svgHeight;
};

GoingSvgTree.prototype.getSvgWidth=function(){
    return this.containerWidth;
};

/**
 * 展开节点
 * @param source
 * @param options
 */
GoingSvgTree.prototype.expandNode=function(source,options){
    let diagonal=this.diagonal;
    let {svg,root,gLink,d3,tree}=options;
    const duration = d3.event && d3.event.altKey ? 2500 : 250;
    const links = root.links();

    //对数据进行转换
    tree(root);

    const transition = svg.transition()
        .duration(duration)
        .attr("class", "svgTree")
        .attr("viewBox", [0, 0,  this.getSvgWidth(root), this.getSvgHeight(root)])//进行高度计算
        .tween("resize", window.ResizeObserver ? null : () => () => svg.dispatch("toggle"));



    //绘制节点
    this._drawNodes(source,options,transition);
    // Update the links…
    const link = gLink.selectAll("path")
        .data(links, d => d.target.id);

    // Enter any new links at the parent's previous position.
    const linkEnter = link.enter().append("path")
        .attr("d", d => {
            const o = {x: source.x0, y: source.y0,path:source.path};
            return diagonal({source: o, target: o});
        });

    // Transition links to their new position.
    link.merge(linkEnter).transition(transition)
        .attr("d", diagonal);

    // Transition exiting nodes to the parent's new position.
    link.exit().transition(transition).remove()
        .attr("d", d => {
            const o = {x: source.x, y: source.y};
            return diagonal({source: o, target: o});
        });

    // Stash the old positions for transition.
    root.eachBefore(d => {
        d.x0 = d.x;
        d.y0 = d.y;
    });

    //设置容器的宽高
    this.setSvgWidth();
    try{
        setTimeout(()=>{
            this.initSvgPosition&&this.initSvgPosition(svg,this,d3);
        },300);
    }catch (e) {
        console.log("==initSvgPosition=");
    }

};


GoingSvgTree.prototype.initSvgPosition=function(svg,treeObj,d3){
    //如果svg对高度大于容器高度 才需要这样移动
    if(this.moveHeight>150){
        svg.call(treeObj.zoom).transition().duration(10).call(
            treeObj.zoom.transform,
            d3.zoomIdentity.translate(100, treeObj.moveHeight)
        );
    }
};
/**
 * 这里需要分节点类型来进行区分绘制 目的在于减少重复线条对绘制。
 * @param d
 * @returns {string}
 */
GoingSvgTree.prototype.diagonal=function(d){
    let nodeDefPadding=60;
    function getNodePadding(d){
        return  (d.nodeWidth||80)+nodeDefPadding-33;
    }
    let yMover=parseInt((d.source.nodeHeight||33)/2);
    var path=null;
    //如果是第一个节点
    if(d.target.first===true){
        path = "M" + (d.source.y ) + " " + (d.source.x+yMover) +
            "L" + (d.source.y + getNodePadding(d.source)) + " " + ( d.source.x+yMover) +
            " L" + (d.source.y + getNodePadding(d.source)) + " " + (d.target.x+yMover) + " L" +
            (d.target.y ) + " " + (d.target.x+yMover);
        return path;
    }
    //如果是最后对节点
    if(d.target.last===true){
        path = "M" + (d.source.y + getNodePadding(d.source)) + " " + ( d.source.x+yMover) +
            "L" + (d.source.y + getNodePadding(d.source)) + " " + ( d.source.x+yMover) +
            " L" + (d.source.y + getNodePadding(d.source)) + " " + (d.target.x+yMover) + " L" +
            (d.target.y ) + " " + (d.target.x+yMover);
        return path;
    }
    //如果是中间节点
    path = "M" + (d.source.y + getNodePadding(d.source))  + " " + (d.target.x+yMover) +
        "L" + (d.source.y + getNodePadding(d.source))  + " " + (d.target.x+yMover) +
        " L" + (d.source.y + getNodePadding(d.source)) + " " + (d.target.x+yMover) + " L" +
        (d.target.y ) + " " + (d.target.x+yMover);
    return path;
};
/**
 * 绘制树
 * @param width
 * @param d3
 * @param data
 * @returns {*}
 */
GoingSvgTree.prototype.drawTree = function ({width, d3, data},treeType="her") {
    let dx = this.options.nodeTopSpace;
    let dy = this.options.nodeLeftSpace;

    this.treeType=treeType;


    const root = d3.hierarchy(data);
    root.x0 = dy / 2;
    root.y0 = 0;
    //设置上下间隔
    const tree = d3.tree().nodeSize([dx, dy]);

    //对显示层级进行控制 超过的层级需要点击去展开收缩
    root.descendants().forEach((d, i) => {
        d.id = i;
        d._children = d.children;
        if(d.depth >=this.options.showLevel){
            if(d.children!=null){
                d.hasChildren=true;
            }
            d.children = null;
        }
    });

    //绘制svg图像
    const svg =  d3.select('#' + this.containerId).append('svg')
        .attr("viewBox", [0, 0, this.containerWidth, dx])
        .style("font", "10px sans-serif")
        .style("user-select", "none");

    this.svg=svg;

    //拖拽svg图像
    function dragged(d) {
        if (d != null) {
            d3.select(this).attr("cx", d.x = d3.event.x).attr("cy", d.y = d3.event.y);
        }
    }
    const g = svg.append("g")
        .attr("font-family", "sans-serif")
        .attr("font-size", 10)
        .call(d3.drag().on("drag", dragged));

    this.svgObj = g;
    //对svg添加缩放功能
    this._initZoom(d3, svg, root, g);

    const gLink = g.append("g")
        .attr("fill", "none")
        .attr("stroke", "#555")
        .attr("stroke-opacity", 0.4)
        .attr("stroke-width", 1.5);

    const gNode = g.append("g")
        .attr("cursor", "pointer")
        .attr("pointer-events", "all");

    this.expandNode(root,{svg,root,gLink,gNode,d3,g,tree,width});


};


/**
 * 获取svg图的宽度
 */
GoingSvgTree.prototype.setSvgWidth=function(){
    let svgWid=this.options.nodeLeftSpace*(this.maxDepth)+300;
    //如果svg的宽度大于容器宽度
    if(svgWid>this.containerWidth){
        if(this.setSvgEye){
            this.scrollerWidth=svgWid-this.containerWidth;
            this.setSvgEye(true);
        }
        this["svgEye"]=true;
        //需要修改容器的宽度
        $('#' + this.containerId).css("width",svgWid);
    }

    //如果svg的高度大于容器高度
    if(this.svgHeight>this.containerHeight){
        $('#' + this.containerId).css("height",this.svgHeight);
    }
};

export default GoingSvgTree;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/goingSvgTree.js